import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";

export default function LandingPage() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSignup = async (e) => {
    e.preventDefault();
    if (!email) {
      setMessage("Please enter a valid email.");
      return;
    }
    try {
      const response = await fetch(`https://us9.api.mailchimp.com/3.0/lists/${process.env.REACT_APP_MAILCHIMP_LIST_ID}/members`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${process.env.REACT_APP_MAILCHIMP_API_KEY}`
        },
        body: JSON.stringify({ email_address: email, status: "subscribed" })
      });
      const responseData = await response.json();
      if (response.ok) {
        setMessage("Thank you for signing up!");
        setEmail("");
      } else if (responseData.title === "Member Exists") {
        setMessage("You are already subscribed!");
      } else {
        setMessage("Failed to subscribe. Try again.");
      }
    } catch (error) {
      setMessage("Error connecting to server.");
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white flex flex-col items-center justify-center px-6">
      {/* SEO Meta Tags */}
      <Helmet>
        <title>AI Procedural Content & NPC Generator | AetherGen.tech</title>
        <meta
          name="description"
          content="AetherGen.tech offers AI-powered tools for game developers, including procedural content generation, NPC behavior, and dynamic quests."
        />
        <meta name="keywords" content="AI game development, procedural content generation, NPC AI tools" />
        <meta name="author" content="AetherGen" />
      </Helmet>

      {/* Hero Section */}
      <div className="text-center max-w-3xl">
        <h1 className="text-4xl font-bold mb-4">AI-Powered Procedural Content & NPC Generator</h1>
        <p className="text-lg text-gray-300 mb-6">
          Generate game levels, quests, and dynamic NPCs with AI. Save development time & enhance gameplay with our SaaS tool.
        </p>
        <form onSubmit={handleSignup} className="flex gap-2 justify-center">
          <Input 
            type="email"
            placeholder="Enter your email" 
            className="w-64 text-black" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button type="submit" className="bg-blue-600 hover:bg-blue-500">Join Beta</Button>
        </form>
        {message && <p className="mt-2 text-sm text-gray-400">{message}</p>}
      </div>
      
      {/* Feature Highlights */}
      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl">
        <div className="p-6 bg-gray-800 rounded-lg shadow-lg">
          <h2 className="text-xl font-semibold">🛠 Procedural Level Generation</h2>
          <p className="text-gray-300 mt-2">Automatically generate terrains, dungeons, and cities using AI-powered tools.</p>
        </div>
        <div className="p-6 bg-gray-800 rounded-lg shadow-lg">
          <h2 className="text-xl font-semibold">🤖 AI-Driven NPCs & Enemy Behavior</h2>
          <p className="text-gray-300 mt-2">Create intelligent NPCs with adaptive enemy combat and dynamic dialogues.</p>
        </div>
        <div className="p-6 bg-gray-800 rounded-lg shadow-lg">
          <h2 className="text-xl font-semibold">🎮 Game Engine Integration</h2>
          <p className="text-gray-300 mt-2">Seamlessly integrate with Unity & Unreal Engine via API.</p>
        </div>
        <div className="p-6 bg-gray-800 rounded-lg shadow-lg">
          <h2 className="text-xl font-semibold">🚀 Fast Cloud-Based API</h2>
          <p className="text-gray-300 mt-2">Access our AI-powered tools via API with real-time data processing.</p>
        </div>
      </div>
    </div>
  );
}
